module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"update_molpay":"Update MOLpay","merchant_id":{"label":"Merchant ID","placeholder":"Write your merchant id key here"},"verify_key":{"label":"Verify key","placeholder":"Write your verify key here"},"secret_key":{"label":"Secret key","placeholder":"Write your secret key here"}}}')
  delete Component.options._Ctor
}
